import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row, ToggleButton, ToggleButtonGroup} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import {ImFolderOpen} from 'react-icons/im'
import {HiFolderAdd} from 'react-icons/hi'
import {GiExitDoor} from 'react-icons/gi'
import { obtenerUrlCarpeta } from '../../store/actions/carpeta-digital-ation'

const Carpeta = ({ prototipo,setSendUrl,setOp,op,handleClose,origen, region, myUrlBase}) => {
  const [value, setValue] = useState(prototipo===4?1:prototipo);
  const data_carpeta = useSelector((state) => state.CarpetaDigitalReducer)
  const { cfg_form30, limpiar} = data_carpeta
  const data_recepciona = useSelector((state) => state.casoGeneralReducer)
  const { llaves,antecedentesCasos} = data_recepciona
  const dispatch=useDispatch()
  
  useEffect(()=>{
    if(op){
      let docs=limpiar==='asegurado' || limpiar===undefined?0:limpiar==='implicado1'?1:limpiar==='implicado2'?2:limpiar==='implicado3'?3:4
      if(op==='cd-view' || prototipo===1){let localQuery = new Buffer(`op=${'cd-view'}&dockey=${llaves && llaves["idCaso"]}&docsubkey=${docs}&owner=${llaves && llaves['idOrgCaso']}&user=${llaves && llaves['idUsuario']}&region=${region}&origenusr=${origen}`)
      dispatch(obtenerUrlCarpeta(localQuery.toString('base64'))) 
    }
    }
  },[op])
  const handleChange = (val) =>{ 
    if(val===1){
      setOp('cd-view')  
    }    
    if(val===2){
      setOp('cd-upload')
    }
    if(val===3){
      handleClose()
    }
    setSendUrl('')
    setValue(val)
  }; 
  return (
    <>
  <style type='text/css'>
                {`
    .btn-botones {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;
      width:'40px';

    }
    .btn-botones:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }    
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    `} </style>
      
        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' ,textAlign:'center' }}
          >
            {` ID CASO- ${llaves && llaves['idCaso']}`}
          </Card.Header>
            <Container>
              {cfg_form30? (
                <div >
                  <Row className='d-flex ' >
                 
                    <Col md='9'>
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                      >
                        {
                          cfg_form30.cfg_form30[
                            'modalcd-lbl-siniestro'
                          ]
                        }
                      </Form.Label>{' '}
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {antecedentesCasos && antecedentesCasos.length !== 'undefined'                 
                        ? antecedentesCasos.antecedentesCasos[0]['Siniestro']
                        : ''}
                      </Form.Text>
                    </Col>
                    
                      <Col style={{alignSelf:'end'}}>
                      <ToggleButtonGroup className='mt-3' type="radio" name='carpeta' defaultValue={1} value={value} onChange={handleChange}>
                          {prototipo!==3 ?<ToggleButton variant='outline-info' id="tbg-btn-1" className='mx-2' value={1}>
                           <ImFolderOpen size={30}/>
                          </ToggleButton>:null}
                          {prototipo!==1 && prototipo!==4 ? <ToggleButton id="tbg-btn-2" variant='outline-info' className='mx-2' value={2}>
                           <HiFolderAdd size={30}/>
                          </ToggleButton>:null}
                          <ToggleButton id="tbg-btn-3"  variant='outline-info' className='mx-2' value={3}>
                           <GiExitDoor size={30}/>
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                  </Row>
                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>
                </div>
              ) : null}
            </Container>
        </Card>
     </>
  )
}
export default Carpeta
